export default "__VITE_ASSET__BogJdfFr__"